import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { CompanyService }        from '../companies/company.service';
import { CompanySettingsModel }  from '../companies/models/company.settings';
import { CustomerPortalService } from './customer-portal.service';
import { MessagesService }       from '../messages/messages.service';

@Component({
  selector   : 'wor-customer-portal-settings',
  template: require('./customer-portal.settings.component.html')
})
export class CustomerPortalSettingsComponent {
  @Input() settings: CompanySettingsModel;

  title : string = this.customerPortalService.title;

  constructor (
    public  companyService       : CompanyService,
    private customerPortalService: CustomerPortalService,
    private messagesService      : MessagesService,
    private router               : UIRouter,
    private translateService     : TranslateService,
  ) {}

  activate () : void {
    this.customerPortalService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  deactivate () : void {
    this.customerPortalService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }
}
